(function () {
  // Prevent double-init if Shopify re-renders sections
  if (window.__rmhInitDone) return;
  window.__rmhInitDone = true;

   // ----------------------------
  // SOURCE OF TRUTH (from Liquid)
  // ----------------------------
  const m = window.RMH?.membership || {};

  // Billing cycles come directly from tags (Liquid → JS)
  const cycles = Number(m.billingCyclesCompleted || 0);

  // Active membership is tag-based
  const isActive = !!m.has_active_membership;

  // Tier flags (already provided by Liquid)
  const isRefine = !!m.is_refine;
  const isContour = !!m.is_contour;
  const isSmooth = !!m.is_smooth;

  // ----------------------------
  // Small helpers
  // ----------------------------
  const $$ = (sel) => Array.from(document.querySelectorAll(sel));
  const setText = (sel, val) => $$(sel).forEach((el) => (el.textContent = String(val)));
  const setHTML = (sel, html) => $$(sel).forEach((el) => (el.innerHTML = html));

  function cyclesToNextMultiple(n) {
    if (n <= 0) return n; // guard
    const mod = cycles % n;
    return mod === 0 ? 0 : n - mod;
  }


  // ----------------------------
  // Credits Overview Collapsible
  // (use button markup: data-rmh-toggle="credits")
  // ----------------------------
  const toggleBtn = document.querySelector('[data-rmh-toggle="credits"]');
  const content = document.getElementById("rmh-collapsible-content");
  const icon = document.getElementById("rmh-collapsible-icon");

  function openCredits() {
    if (!content) return;
    content.style.maxHeight = content.scrollHeight + "px";
    if (icon) icon.textContent = "▲";
  }

  function closeCredits() {
    if (!content) return;
    content.style.maxHeight = null;
    if (icon) icon.textContent = "▼";
  }

  function toggleCredits() {
    if (!content) return;
    if (content.style.maxHeight) closeCredits();
    else openCredits();
  }

  if (toggleBtn && content) {
    toggleBtn.addEventListener("click", function (e) {
      e.preventDefault();
      toggleCredits();
    });
  }

  // ----------------------------
  // Concierge Reveal (Refine)
  // (use button markup: data-rmh-reveal="concierge")
  // ----------------------------
  const revealBtn = document.querySelector('[data-rmh-reveal="concierge"]');
  const conciergeNumber = document.getElementById("rmh-concierge-number");

  if (revealBtn && conciergeNumber) {
    revealBtn.addEventListener("click", function (e) {
      e.preventDefault();
      conciergeNumber.style.display = "block";
      revealBtn.style.display = "none";
    });
  }

  // ----------------------------
  // Display the cycle count anywhere needed
  // (optional hook you may have elsewhere)
  // ----------------------------
  setText("[data-rmh-cycles]", cycles);

  // ----------------------------
  // REWARDS (YES/NO, NON-AGGREGATING)
  // ----------------------------
  // Rule: "Every 3 cycles" rewards show as either:
  // - AVAILABLE (1 credit max)
  // - or progress to next eligibility
  const eligibleEvery3 = isActive && cycles >= 3;
  const untilNext3 = isActive ? cyclesToNextMultiple(3) : null;

  const earned3Count = isActive ? Math.floor(cycles / 3) : 0; // for messaging only

  // --- TOX (all tiers): 30 units every 3 consecutive cycles
  const toxUnits = eligibleEvery3 ? 30 : 0;
  setText("[data-rmh-tox-units]", toxUnits);

  if (!isActive) {
    setText("[data-rmh-tox-note]", "Membership inactive — credits paused");
  } else if (!eligibleEvery3) {
    setText("[data-rmh-tox-note]", `Unlocks in ${Math.max(0, 3 - cycles)} consecutive cycles`);
  } else if (untilNext3 === 0) {
    setText("[data-rmh-tox-note]", "Available now (renews every 3 consecutive cycles)");
  } else {
    setText("[data-rmh-tox-note]", `Available now · Next renewal in ${untilNext3} cycles`);
  }

  // --- LASER & ENERGY DEVICE credit (Contour/Refine only), every 3 cycles.
  // IV credits were retired 2026-07-27; their value is folded in here so members
  // lose nothing. The tier marketing copy already promised the COMBINED totals
  // ($250 Contour / $500 Refine), so the card previously under-displayed:
  //   Contour  laser 150 + iv 100 -> 250
  //   Refine   laser 300 + iv 200 -> 500
  // Amounts now match the advertised tier copy exactly.
  let laserAmount = 0;

  if (isContour) {
    laserAmount = 250;
  }
  if (isRefine) {
    laserAmount = 500;
  }

  // Laser
  if (isContour || isRefine) {
    setText("[data-rmh-laser-credit]", eligibleEvery3 ? laserAmount : 0);

    if (!isActive) {
      setText("[data-rmh-laser-note]", "Membership inactive — credits paused");
    } else if (!eligibleEvery3) {
      setText("[data-rmh-laser-note]", `Unlocks in ${Math.max(0, 3 - cycles)} consecutive cycles`);
    } else if (untilNext3 === 0) {
      setText("[data-rmh-laser-note]", "Available now (renews every 3 consecutive cycles)");
    } else {
      setText("[data-rmh-laser-note]", `Available now · Next renewal in ${untilNext3} cycles`);
    }
  }

  // IV credit block removed 2026-07-27 — the credit is retired and its value is
  // folded into laserAmount above. The [data-rmh-iv-*] elements no longer exist.

  // --- FILLER (Contour + Refine): unlock at 12 consecutive cycles (one-time unlock)
  const fillerGoal = 12;
  const fillerUnlocked = isActive && cycles >= fillerGoal;
  const fillerProgress = Math.min(cycles, fillerGoal);

  setText("[data-rmh-filler-cycles]", fillerProgress);

  // A simple yes/no hook you added
  setText("[data-rmh-filler-eligible]", fillerUnlocked ? "✅ Reward unlocked" : "—");

  if (!isActive) {
    setText("[data-rmh-filler-note]", "Membership inactive — loyalty progress paused");
  } else if (fillerUnlocked) {
    setText("[data-rmh-filler-note]", "Reward unlocked — free syringe available");
  } else {
    setText(
      "[data-rmh-filler-note]",
      `Unlocks in ${Math.max(0, fillerGoal - cycles)} consecutive cycles`
    );
  }

  // --- AMBASSADOR (Refine only): 2 x $100 gift cards every 6 cycles (twice a year)
  // Non-aggregating: show 2 cards if eligible, else 0.
  // (We don’t track redemption here; this is eligibility-based.)
  if (isRefine) {
    const ambassadorEvery = 6;
    const eligibleAmbassador = isActive && cycles >= ambassadorEvery;
    const untilNext6 = isActive ? cyclesToNextMultiple(ambassadorEvery) : null;

    const ambassadorCards = eligibleAmbassador ? 2 : 0;
    setText("[data-rmh-ambassador-cards]", ambassadorCards);

    // Optional: if you later add a note hook, we can wire it too.
    // For now, eligibility is enough to stop “0” confusion.
  }

console.log("LOUNGE JS: TOP OF FILE REACHED");

// ----------------------------
// RMH LOUNGE: OPEN MODAL
// ----------------------------
function RMH_Lounge_OpenModal() {
  const modal = document.getElementById('lounge-modal');
  if (modal) modal.classList.remove('hidden');
}

// ----------------------------
// RMH LOUNGE: CLOSE MODAL
// ----------------------------
function RMH_Lounge_CloseModal() {
  const modal = document.getElementById('lounge-modal');
  if (modal) modal.classList.add('hidden');
}

// ----------------------------
// GLOBAL STATE
// ----------------------------
window.RMH_Lounge_CurrentProduct = null;
window.RMH_Lounge_SelectedVariant = null;

// ----------------------------
// RMH LOUNGE: INIT
// ----------------------------
function RMH_Lounge_Init() {
  // Close modal
  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('.lounge-modal__close');
    if (closeBtn) RMH_Lounge_CloseModal();
  });
}

// ----------------------------
// RENDER PRODUCT DETAILS
// ----------------------------
function RMH_Lounge_RenderProduct(product) {
  window.RMH_Lounge_CurrentProduct = product;
  // Don't force a variant here; let the variant block handle it
  window.RMH_Lounge_SelectedVariant = null;

  // ⭐ back button + state
  const backBtn = document.querySelector('.lounge-back-button');
  if (backBtn) backBtn.classList.remove('hidden');
  window.RMH_Lounge_LastView = "product";

  const titleEl = document.querySelector('.lounge-modal__title');
  const priceEl = document.querySelector('.lounge-modal__price');
  const variantsEl = document.querySelector('.lounge-modal__variants');
  const mediaEl = document.querySelector('.lounge-modal__media');
  const detailsLink = document.querySelector('.lounge-modal__details-link');

  // Title
  if (titleEl) titleEl.textContent = product.title;

 // Price is intentionally hidden here — member/sale pricing varies and
 // was showing inconsistently on-page, so it's revealed in the cart instead.
if (priceEl) {
  priceEl.innerHTML = `<div class="lounge-modal-price-teaser">Add to cart to see your exclusive price</div>`;
}




  // Product image
  if (mediaEl) {
    const firstImage = product.images && product.images.length > 0
      ? product.images[0]
      : null;

    mediaEl.innerHTML = firstImage
      ? `<img src="${firstImage}" alt="${product.title}" class="lounge-modal__image">`
      : "";
  }

  // Details link
  if (detailsLink) {
    detailsLink.href = `/products/${product.handle}`;
    detailsLink.style.display = 'block';
  }

  // Variants
  if (variantsEl) {
    variantsEl.innerHTML = "";

    if (product.variants.length > 1) {
      variantsEl.style.display = "";
      product.variants.forEach((variant) => {
        const btn = document.createElement('button');
        btn.className = 'lounge-variant-option';
        btn.dataset.variantId = variant.id;
        btn.textContent = variant.title;
        variantsEl.appendChild(btn);
      });
    } else {
      // Single-variant product (memberships, etc.)
      variantsEl.style.display = "none";

      // Auto-select the only variant so Add to Cart works
      if (product.variants[0]) {
        window.RMH_Lounge_SelectedVariant = product.variants[0].id;
      }
    }
  }
}




// ----------------------------
// LOAD PRODUCT BY HANDLE
// ----------------------------
async function RMH_Lounge_LoadProduct(handle) {
  try {
    const product = await fetch(`/products/${handle}.js`).then((r) => r.json());
    RMH_Lounge_RenderProduct(product);
  } catch (err) {
    console.error("RMH Lounge: Failed to load product JSON", err);
  }
}

// ----------------------------
// PRODUCT TRIGGER → LOAD PRODUCT
// ----------------------------
document.addEventListener("click", async (e) => {
  const trigger = e.target.closest(".lounge-product-trigger");
  if (!trigger) return;

  console.log("LOUNGE: Trigger dataset →", trigger.dataset);

  const handle = trigger.dataset.handle;
  if (!handle) return;

  window.RMH_Lounge_SellingPlanId = trigger.dataset.sellingPlanId || null;
  console.log("LOUNGE: Captured selling plan →", window.RMH_Lounge_SellingPlanId);

  await RMH_Lounge_LoadProduct(handle);
  RMH_Lounge_OpenModal();
});



// ----------------------------
// COLLECTION → FETCH PRODUCTS
// ----------------------------
document.addEventListener("click", async (e) => {
  const trigger = e.target.closest(".lounge-collection-trigger");
  if (!trigger) return;

  const collectionHandle = trigger.dataset.collection;
  if (!collectionHandle) return;

  console.log("RMH Lounge: Loading collection:", collectionHandle);

  try {
    const res = await fetch(`/collections/${collectionHandle}/products.json`);
    const data = await res.json();

    if (!data.products || data.products.length === 0) {
      console.warn("RMH Lounge: No products found in collection:", collectionHandle);
      return;
    }

    RMH_Lounge_RenderCollectionProducts(data.products);
    RMH_Lounge_OpenModal();
  } catch (err) {
    console.error("RMH Lounge: Failed to load collection:", err);
  }
});

function RMH_Lounge_RenderCollectionProducts(products) {
  const titleEl = document.querySelector(".lounge-modal__title");
  const priceEl = document.querySelector(".lounge-modal__price");
  const variantsEl = document.querySelector(".lounge-modal__variants");
  const mediaEl = document.querySelector(".lounge-modal__media");
  const backBtn = document.querySelector(".lounge-back-button");

  // ⭐ NEW: track state + show back button
  window.RMH_Lounge_LastCollectionProducts = products;
  window.RMH_Lounge_LastView = "collection";
  if (backBtn) backBtn.classList.remove("hidden");

  if (titleEl) titleEl.textContent = "Select a Product";
  if (priceEl) priceEl.textContent = "";
  if (variantsEl) variantsEl.innerHTML = "";
  if (mediaEl) mediaEl.innerHTML = "";

  mediaEl.innerHTML = `
    <div class="lounge-collection-list">
      ${products
        .map(
          (p) => `
        <button class="lounge-collection-product" data-handle="${p.handle}">
          ${p.title}
        </button>
      `
        )
        .join("")}
    </div>
  `;
}



// ----------------------------
// COLLECTION PRODUCT → LOAD PRODUCT
// ----------------------------
document.addEventListener("click", async (e) => {
  const option = e.target.closest(".lounge-collection-product");
  if (!option) return;

  const handle = option.dataset.handle;
  if (!handle) return;

  console.log("RMH Lounge: Loading product from collection:", handle);

  await RMH_Lounge_LoadProduct(handle);
});

// ----------------------------
// VARIANT SELECTION
// ----------------------------
document.addEventListener("click", (e) => {
  const btn = e.target.closest(".lounge-variant-option");
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  window.RMH_Lounge_SelectedVariant = variantId;

  document
    .querySelectorAll(".lounge-variant-option")
    .forEach((b) => b.classList.toggle("active", b === btn));
});

// ----------------------------
// ADD TO CART
// ----------------------------

async function loungeAddToCart() {
  const variantId = window.RMH_Lounge_SelectedVariant;
  console.log("LOUNGE: Selected variant →", variantId);

  if (!variantId) {
    console.warn("LOUNGE: No variant selected — cannot add to cart");
    return;
  }

  try {
   const payload = {
  id: variantId,
  quantity: 1,
};

// ⭐ ADD THIS — the selling plan you already captured
if (window.RMH_Lounge_SellingPlanId) {
  payload.selling_plan = window.RMH_Lounge_SellingPlanId;
}

    console.log("LOUNGE: Payload being sent →", payload);

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const responseText = await res.text();
    console.log("LOUNGE: Shopify response →", res.status, responseText);

    if (res.ok && typeof wlTryOpenCartDrawer === "function") {
      wlTryOpenCartDrawer();
    }
  } catch (err) {
    console.error("RMH Lounge: Add to cart failed:", err);
  }
}

document.addEventListener("click", (e) => {
  const btn = e.target.closest(".lounge-modal__add-to-cart");
  if (!btn) return;

  e.preventDefault();
  e.stopImmediatePropagation(); // ⭐ BLOCK ALL OTHER SCRIPTS

  loungeAddToCart();
});


document.addEventListener("click", (e) => {
  const backBtn = e.target.closest(".lounge-back-button");
  if (!backBtn) return;

  if (window.RMH_Lounge_LastView === "product") {
    if (window.RMH_Lounge_LastCollectionProducts) {
      RMH_Lounge_RenderCollectionProducts(window.RMH_Lounge_LastCollectionProducts);
    }
    return;
  }

  if (window.RMH_Lounge_LastView === "collection") {
    RMH_Lounge_CloseModal();
    return;
  }
});

// ----------------------------
// RIVO: "View Rewards" button — its own anchor target no longer
// resolves to anything on this page, so the click just snapped
// scroll position back to the top. Intercept by button text (not by
// Rivo's internal class names, which we don't control) and scroll to
// the "Your Current Membership Rewards" section instead.
// ----------------------------
document.addEventListener(
  "click",
  (e) => {
    const trigger = e.target.closest("#rivo-account-dashboard a, #rivo-account-dashboard button");
    if (!trigger) return;

    const label = (trigger.textContent || "").trim().toLowerCase();
    if (label !== "view rewards") return;

    const rewardsSection = document.querySelector(".rivo-lp-section-title");
    if (!rewardsSection) return; // fall back to Rivo's default behavior if we can't find it

    e.preventDefault();
    e.stopPropagation();
    rewardsSection.scrollIntoView({ behavior: "smooth", block: "start" });
  },
  true
);




// ----------------------------
// INIT (RUN ON LOAD)
// ----------------------------
RMH_Lounge_Init();


// ----------------------------
// EXPORTS
// ----------------------------
window.RMH_Lounge_OpenModal = RMH_Lounge_OpenModal;
window.RMH_Lounge_CloseModal = RMH_Lounge_CloseModal;
window.RMH_Lounge_LoadProduct = RMH_Lounge_LoadProduct;
window.RMH_Lounge_SetSelectedVariant = (id) =>
  (window.RMH_Lounge_SelectedVariant = id);

window.RMH_Lounge_AddToCart = loungeAddToCart;
window.RMH_Lounge_Init = RMH_Lounge_Init;

console.log("[LOUNGE] loaded");


/********************
 * REWARDS (UNCHANGED)
 ********************/
window.RMH = window.RMH || {};
window.RMH.rewards = {
  isActive,
  cycles,
  tier: isRefine ? "refine" : isContour ? "contour" : isSmooth ? "smooth" : "unknown",
};


console.log("[RMH][rewards]", window.RMH.rewards);
})();
